import React from "react";
import moment from "moment";
import { Row, Col } from "antd";
import { SelectItem, RangePickerItem } from "../../../Components/Items";

// Mismos presets/rangos que ya usa ReporteVentas.js (calcularRangoPeriodo) --
// se replican igual para que el usuario encuentre el mismo comportamiento.
export function calcularRangoPeriodo(preset) {
  switch (preset) {
    case "hoy":
      return [moment().startOf("day"), moment().endOf("day")];
    case "ayer":
      return [moment().subtract(1, "day").startOf("day"), moment().subtract(1, "day").endOf("day")];
    case "semana":
      return [moment().startOf("week"), moment().endOf("week")];
    case "mes":
      return [moment().startOf("month"), moment().endOf("month")];
    case "mesPasado":
      return [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")];
    case "trimestre":
      return [moment().startOf("quarter"), moment().endOf("quarter")];
    case "anio":
      return [moment().startOf("year"), moment().endOf("year")];
    case "anioPasado":
      return [moment().subtract(1, "year").startOf("year"), moment().subtract(1, "year").endOf("year")];
    case "ultimos30":
    default:
      return [moment().subtract(1, "month"), moment()];
  }
}

const OPCIONES_PRESET = [
  { value: "hoy", label: "Hoy" },
  { value: "ayer", label: "Ayer" },
  { value: "semana", label: "Esta semana" },
  { value: "mes", label: "Este mes" },
  { value: "mesPasado", label: "Mes pasado" },
  { value: "trimestre", label: "Este trimestre" },
  { value: "anio", label: "Este año" },
  { value: "anioPasado", label: "Año pasado" },
  { value: "ultimos30", label: "Últimos 30 días" },
  { value: "personalizado", label: "Personalizado" },
];

// Filtro de periodo SIEMPRE visible (no depende de qué columnas eligió el
// usuario) -- escribe directo en filtros[campoFechaKey] con el mismo shape
// {desde, hasta} que ya entiende el motor de filtros genérico (tipo "fecha").
function SelectorPeriodoReporte({ preset, rango, onChange }) {
  const onChangePreset = (nuevoPreset) => {
    if (nuevoPreset === "personalizado") {
      onChange({ preset: nuevoPreset, rango });
      return;
    }
    const [desde, hasta] = calcularRangoPeriodo(nuevoPreset);
    onChange({ preset: nuevoPreset, rango: [desde, hasta] });
  };

  const onChangeRango = (fechas) => {
    onChange({ preset: "personalizado", rango: fechas });
  };

  return (
    <Row gutter={8} style={{ flexWrap: "nowrap", alignItems: "center" }}>
      <Col flex="none">
        <SelectItem width={160} value={preset} onChange={onChangePreset} options={OPCIONES_PRESET} />
      </Col>
      <Col flex="auto">
        <RangePickerItem value={rango} onChange={onChangeRango} style={{ width: "100%" }} />
      </Col>
    </Row>
  );
}

export default SelectorPeriodoReporte;
